import React from "react";

export function Row ({header, children }) {
    return <li>
        <h3 style={{margin:".4em"}}>{header}</h3>
        <div style={{marginLeft:"3em"}}>{children}</div>
    </li>
}